module.exports = __webpack_public_path__ + "dtiys.png?71ef51ba809f831ad3bee6142ab12dbc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dtiys.png
// module id = 25
// module chunks = 0